import React from "react";

import { useThemeProps } from "../../../../../../wsui/base/index.js";

import PageModules from "./PageModules.jsx";

export default function PageContentAreaTopModules(props) {
  props = useThemeProps({ props, name: "PageContentAreaTopModules" });
  let { ...restProps } = props;
  return <PageModules area="contentAreaTop" {...restProps} />;
}
